module.exports = __webpack_public_path__ + "static/media/or.248daa00.JPG";